<template>
  <div>    
    <div class="center">
      <img src="@/assets/logo-mdh-mn-h-blu_rgb.png" style="height:38px;" alt="Minnesota Department of Health Logo"/>
    </div>

    <b-row class="mt-5">
      <b-col>
        <p>
          <span class="font-weight-bold">Order Number: </span>
          <span>{{orderId}}</span>
        </p>
        <p>
          <span class="font-weight-bold">Requester Name: </span>
          <span>{{fullName}}</span>
        </p>
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col>
        This cover sheet must be enclosed with your amendment documents.
        This helps us find and process your online order.
        Sending documents without a cover sheet may delay the requested amendment.
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col cols="6">
        <p class="font-weight-bold">Send your documents and cover sheet by mail to:</p>
        <div>Minnesota Department of Health</div>
        <div>Office of Vital Records</div>
        <div>PO Box 64499</div>
        <div>St. Paul, MN 55164-0499</div>
      </b-col>
      <b-col cols="6">
        <p class="font-weight-bold">Send your documents and cover sheet by courier/express delivery:</p>
        <div>Minnesota Department of Health</div>
        <div>Office of Vital Records</div>
        <div>625 Robert St. N</div>
        <div>St. Paul, MN 55155</div>
      </b-col>
    </b-row>
  </div>
</template>

<script>

import axios from "axios";
import LocalStorageService from "@/common/LocalStorageService";
import axiosRetry from 'axios-retry'

const localStorageService = LocalStorageService.getService();

axiosRetry(axios, { retries: 3,
  retryDelay: axiosRetry.exponentialDelay  })

export default {
  name: 'Coversheet',
  data: () => {
    return {
      orderNumber: null,
      fullName: null,
      orderId: null,
    }
  },
  mounted() {
    this.orderNumber = localStorageService.getOrderNumber()
    this.loadName()
  },
  methods: {
    loadName() {
      axios.get(`${process.env.VUE_APP_API_BASE_URL}/order/coversheet/${this.orderNumber}`)
          .then(response => {
            let data = response.data
            this.fullName = data.fullName
            this.orderId = data.orderNumber
          })
          .finally(()=>{
            print()
          })
    }
  }
}
</script>
